import React from 'react';

// ── DEFAULT PROFILE PICTURE ──────────────────────────────────────────────────
// The placeholder shown wherever someone has not uploaded a photo. Replaces
// the initials tile: initials are a poor default at small sizes, mangle
// non-Latin names, and turn every avatar into a different-looking object —
// where one consistent glyph reads immediately as "no picture".
//
// SIZED BY ITS CONTAINER, not by a prop. Every avatar in the app is a circle
// with a known size (26px in the tab bar, 98px on a profile card), so the
// glyph is 60% of whichever circle it lands in and nobody has to pass a
// number that could disagree with the CSS.
//
// `currentColor` so it inherits the avatar's own colour, and aria-hidden
// because the surrounding control already carries the person's name.
export default function PersonIcon({ className = '' }) {
  return (
    <svg
      className={`person-icon${className ? ` ${className}` : ''}`}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 12.2a4.6 4.6 0 1 0 0-9.2 4.6 4.6 0 0 0 0 9.2z" />
      <path d="M12 14.3c-4.3 0-7.8 2.6-7.8 5.9 0 .5.4.8.9.8h13.8c.5 0 .9-.3.9-.8 0-3.3-3.5-5.9-7.8-5.9z" />
    </svg>
  );
}
